export default "__VITE_ASSET__D9UYmf9M__"